import { render } from "./MsgUserContentList.vue?vue&type=template&id=a464ae72"
import script from "./MsgUserContentList.vue?vue&type=script&lang=js"
export * from "./MsgUserContentList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__